module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 120,
	"w": 360,
	"h": 360,
	"nm": "A new kind of buy",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Höger ram 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 180,
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.105882352941,
									0.105882352941,
									0.105882352941,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 5,
			"nm": "A NEW KIND OF BUY",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									0.833
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 0,
							"s": [
								281
							]
						},
						{
							"t": 119,
							"s": [
								410
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						180.023,
						180.085,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-3,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						93,
						93,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [
				{
					"inv": false,
					"mode": "n",
					"pt": {
						"a": 0,
						"k": {
							"i": [
								[
									99.357,
									0
								],
								[
									0,
									-99.357
								],
								[
									-99.357,
									0
								],
								[
									0,
									99.357
								]
							],
							"o": [
								[
									-99.357,
									0
								],
								[
									0,
									99.357
								],
								[
									99.357,
									0
								],
								[
									0,
									-99.357
								]
							],
							"v": [
								[
									-0.121,
									-184.085
								],
								[
									-180.023,
									-4.182
								],
								[
									-0.121,
									175.72
								],
								[
									179.782,
									-4.182
								]
							],
							"c": true
						},
						"ix": 1
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 3
					},
					"x": {
						"a": 0,
						"k": 0,
						"ix": 4
					},
					"nm": "Mask 1"
				}
			],
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 35,
								"f": "LabilGrotesk-Bold",
								"t": "A NEW KIND OF BUY",
								"j": 2,
								"tr": 114,
								"lh": 42,
								"ls": 0,
								"fc": [
									0.106,
									0.106,
									0.106
								]
							},
							"t": 0
						}
					]
				},
				"p": {
					"m": 0,
					"f": {
						"a": 0,
						"k": 0,
						"ix": 5
					},
					"l": {
						"a": 0,
						"k": 0,
						"ix": 6
					},
					"a": 0,
					"p": 1,
					"r": 0
				},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": []
			},
			"ip": 0,
			"op": 120,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "A",
			"size": 35,
			"style": "Bold",
			"w": 75.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												57.907,
												0
											],
											[
												74.02,
												0
											],
											[
												47.635,
												-70.496
											],
											[
												28.198,
												-70.496
											],
											[
												1.712,
												0
											],
											[
												17.12,
												0
											],
											[
												23.163,
												-16.718
											],
											[
												51.865,
												-16.718
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												27.695,
												-29.205
											],
											[
												37.463,
												-56.094
											],
											[
												47.232,
												-29.205
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "A",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "A",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": " ",
			"size": 35,
			"style": "Bold",
			"w": 17.8,
			"data": {},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "N",
			"size": 35,
			"style": "Bold",
			"w": 71.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.041,
												-47.534
											],
											[
												50.354,
												0
											],
											[
												66.769,
												0
											],
											[
												66.769,
												-70.496
											],
											[
												50.958,
												-70.496
											],
											[
												51.764,
												-22.961
											],
											[
												21.451,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "N",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "E",
			"size": 35,
			"style": "Bold",
			"w": 58.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												55.087,
												0
											],
											[
												55.087,
												-12.891
											],
											[
												21.35,
												-12.891
											],
											[
												21.35,
												-29.608
											],
											[
												51.059,
												-29.608
											],
											[
												51.059,
												-41.592
											],
											[
												21.35,
												-41.592
											],
											[
												21.35,
												-57.806
											],
											[
												54.684,
												-57.806
											],
											[
												54.684,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "E",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "E",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "W",
			"size": 35,
			"style": "Bold",
			"w": 103.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.048,
												0
											],
											[
												39.478,
												0
											],
											[
												52.167,
												-52.67
											],
											[
												64.755,
												0
											],
											[
												83.084,
												0
											],
											[
												103.226,
												-70.496
											],
											[
												85.904,
												-70.496
											],
											[
												73.718,
												-20.242
											],
											[
												61.935,
												-70.496
											],
											[
												42.7,
												-70.496
											],
											[
												30.817,
												-20.242
											],
											[
												18.228,
												-70.496
											],
											[
												0.806,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "W",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "W",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "K",
			"size": 35,
			"style": "Bold",
			"w": 67.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												67.172,
												-70.496
											],
											[
												47.433,
												-70.496
											],
											[
												20.847,
												-40.988
											],
											[
												20.847,
												-70.496
											],
											[
												5.035,
												-70.496
											],
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.847,
												-20.444
											],
											[
												30.817,
												-31.219
											],
											[
												48.239,
												0
											],
											[
												66.669,
												0
											],
											[
												41.995,
												-43.304
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "K",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "K",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "I",
			"size": 35,
			"style": "Bold",
			"w": 27.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.841,
												0
											],
											[
												21.954,
												0
											],
											[
												21.954,
												-70.496
											],
											[
												5.841,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "I",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "D",
			"size": 35,
			"style": "Bold",
			"w": 72.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												20.746
											],
											[
												22.156,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												22.156,
												0
											],
											[
												0,
												-20.746
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												31.824,
												0
											],
											[
												69.489,
												-35.248
											],
											[
												31.824,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-13.193
											],
											[
												12.589,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												12.589,
												0
											],
											[
												0,
												13.193
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												21.149,
												-12.891
											],
											[
												21.149,
												-57.605
											],
											[
												31.622,
												-57.605
											],
											[
												53.073,
												-35.248
											],
											[
												31.622,
												-12.891
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "D",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "D",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "O",
			"size": 35,
			"style": "Bold",
			"w": 80.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.847,
												0
											],
											[
												0,
												20.847
											],
											[
												20.847,
												0
											],
											[
												0,
												-20.746
											]
										],
										"o": [
											[
												21.048,
												0
											],
											[
												0,
												-21.048
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												40.384,
												2.014
											],
											[
												77.646,
												-35.248
											],
											[
												40.384,
												-72.51
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												11.581,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.581,
												0
											],
											[
												0,
												-13.293
											]
										],
										"o": [
											[
												-11.783,
												0
											],
											[
												0,
												-13.495
											],
											[
												11.783,
												0
											],
											[
												0,
												13.394
											]
										],
										"v": [
											[
												40.384,
												-12.488
											],
											[
												19.537,
												-35.248
											],
											[
												40.384,
												-58.109
											],
											[
												61.23,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "O",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "F",
			"size": 35,
			"style": "Bold",
			"w": 54.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												21.35,
												0
											],
											[
												21.35,
												-27.997
											],
											[
												50.354,
												-27.997
											],
											[
												50.354,
												-40.485
											],
											[
												21.35,
												-40.485
											],
											[
												21.35,
												-57.605
											],
											[
												52.368,
												-57.605
											],
											[
												52.368,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "F",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "B",
			"size": 35,
			"style": "Bold",
			"w": 65.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												11.38
											],
											[
												8.963,
												1.611
											],
											[
												0,
												7.05
											],
											[
												13.394,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												13.495,
												0
											],
											[
												0,
												-8.661
											],
											[
												7.15,
												-1.913
											],
											[
												0,
												-11.581
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												39.679,
												0
											],
											[
												62.54,
												-19.235
											],
											[
												48.038,
												-35.751
											],
											[
												60.123,
												-50.858
											],
											[
												37.363,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.935
											],
											[
												5.338,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												5.338,
												0
											],
											[
												0,
												5.035
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												20.847,
												-41.492
											],
											[
												20.847,
												-58.31
											],
											[
												35.55,
												-58.31
											],
											[
												44.614,
												-49.951
											],
											[
												35.55,
												-41.492
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 2,
								"ty": "sh",
								"ix": 3,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-5.035
											],
											[
												5.237,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												5.237,
												0
											],
											[
												0,
												5.136
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												20.847,
												-12.387
											],
											[
												20.847,
												-29.507
											],
											[
												37.766,
												-29.507
											],
											[
												46.628,
												-20.947
											],
											[
												37.766,
												-12.387
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "B",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "B",
						"np": 6,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "U",
			"size": 35,
			"style": "Bold",
			"w": 69,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-18.228,
												0
											],
											[
												0,
												17.624
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												8.862,
												0
											],
											[
												0,
												9.668
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												18.228,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.668
											],
											[
												-8.862,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												17.624
											]
										],
										"v": [
											[
												34.744,
												1.41
											],
											[
												65.46,
												-28.198
											],
											[
												65.46,
												-70.496
											],
											[
												49.146,
												-70.496
											],
											[
												49.146,
												-28.702
											],
											[
												34.744,
												-13.092
											],
											[
												20.343,
												-28.702
											],
											[
												20.343,
												-38.672
											],
											[
												20.343,
												-70.496
											],
											[
												4.028,
												-70.496
											],
											[
												4.028,
												-38.672
											],
											[
												4.028,
												-28.198
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "U",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "Y",
			"size": 35,
			"style": "Bold",
			"w": 68.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.385,
												0
											],
											[
												42.599,
												0
											],
											[
												42.599,
												-23.969
											],
											[
												68.179,
												-70.496
											],
											[
												50.253,
												-70.496
											],
											[
												34.543,
												-41.089
											],
											[
												18.933,
												-70.496
											],
											[
												0.806,
												-70.496
											],
											[
												26.385,
												-23.969
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "Y",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "Y",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/A_new_kind_of_buy.json
// module id = 37
// module chunks = 0